import React from 'react'; 
import {AiOutlineHome} from 'react-icons/ai';
import {AiOutlineCloudUpload} from 'react-icons/ai';
import bidayuh from '../images/bidayuh_icon.png';
import iban from '../images/iban_icon.png';
import ulu from '../images/ulu_icon.png';
import malay from '../images/malay_icon.png';
import melanau from '../images/melanau_icon.png';
import '../components/Navbar.css';


const Navbar = () =>  {

 
    return ( 
        <div className='navigation'> 
            <ul>
                <li>
                    <a href='/'> 
                        <span className='icon'> <AiOutlineHome/></span>
                        <span className='title'> Home</span>
                    </a> 
                </li> 
                <li>
                    <a href='/Bidayuh'> 
                        <span className='icon1'> <img src={bidayuh} alt='bidayuh'/> </span>
                        <span className='title' > 
                            Bidayuh 
                        </span>
                    </a> 
                </li> 
                <li>
                    <a href='/Iban'> 
                        <span className='icon2'> <img src={iban} alt = 'iban'/> </span>
                        <span className='title'> Iban</span>
                    </a> 
                </li> 
                <li>
                    <a href='/Ulu'> 
                        <span className='icon3'> <img src={ulu} alt='ulu'/>  </span>
                        <span className='title'> Orang Ulu</span>
                    </a> 
                </li> 
                <li>
                    <a href='/Melanau'> 
                        <span className='icon4'> <img src={melanau} alt ='melanau'/> </span>
                        <span className='title'> Melanau </span>
                    </a> 
                </li> 
                <li>
                    <a href='/Malay'> 
                        <span className='icon5'> <img src={malay} alt = 'malay' />  </span>
                        <span className='title'> Malay</span>
                    </a> 
                </li> 
                <li>
                    <a href='/Contribute'> 
                        <span className='icon'> <AiOutlineCloudUpload/> </span>
                        <span className='title'> Contribute </span>
                    </a> 
                </li> 
            </ul>
        
        </div>
    );
}

export default Navbar; 
